import { Observable } from 'rxjs';

/** Cached base64 images by gid */
export const EMPLOYEE_PICTURE_CACHE: { [gid: string]: Observable<string | null> } = {};
